function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "770096E1-7618-42E0-BB7F-2ACD55F57DDB");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "path-1",
  cx: 30,
  cy: 30,
  r: 30
}), React.createElement("filter", {
  x: "-37.5%",
  y: "-37.5%",
  width: "175.0%",
  height: "175.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feMorphology", {
  radius: 1,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 6.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.218149038 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Pagina_principal",
  transform: "translate(-33.000000, -371.000000)"
}, React.createElement("g", {
  id: "izq",
  transform: "translate(48.000000, 386.000000)"
}, React.createElement("g", {
  id: "Oval"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("polyline", {
  id: "Path-7",
  stroke: "#EE3746",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "33 21 22 30.685561 33 39.7705013"
}))));

var SvgIzq = function SvgIzq(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIzq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/izq.45850ac6.svg";
export { ForwardRef as ReactComponent };